// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6be4338","239":"3b53faa1","453":"7e49bf80","667":"275d312f"}[chunkId] + ".chunk.js";
};